// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"e9fd3841","198":"9cd20ca9","286":"2958214a","325":"cd87d9ad","379":"5327a932","453":"c63328af","493":"c2e1c569","607":"a746e536","760":"c8665bd9","900":"9441f2bf"}[chunkId] + ".chunk.js";
};